<kendo-dialog
	title="Reset Password"
	*ngIf="dialogOpened"
	(close)="close('dialog')"
	[minWidth]="250"
	[width]="350">
	<div>
		<p>No registered email address associated with this account, please contact support</p>
	</div>
	<kendo-dialog-actions [layout]="'start'">
		<button
			kendoButton
			kpaKendoButton="secondary"
			(click)="close('dialog')">
			Okay</button
		>&nbsp;
	</kendo-dialog-actions>
</kendo-dialog>
